import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
} from '../Button.h'

export interface ISecondaryCloseSolidButtonProps extends IButtonProps {}

export const SecondaryCloseSolidButton = ({
  icon = IconNames.close,
  corners = ButtonCorners.CORNERS_PILL,
  paddings = [FIXED_INDENTS.INDENT_30],
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_TEXT_TERTIARY,
  backgroundColorDefault = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorHovered = COLOR.SURFACE_OPACITY_LIGHT_10,
  backgroundColorPressed = COLOR.SURFACE_OPACITY_DARK_25,
  backgroundColorDisabled = COLOR.SURFACE_DARK_5,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.FontSmBold,
  fluid = ButtonFluid.None,
  onClick,
  ...rest
}: ISecondaryCloseSolidButtonProps): JSX.Element => (
  <Button
    icon={icon}
    iconSize={ButtonIconSizes.small}
    corners={corners}
    paddings={paddings}
    colorDefault={colorDefault}
    colorDisabled={colorDisabled}
    backgroundColorDefault={backgroundColorDefault}
    backgroundColorHovered={backgroundColorHovered}
    backgroundColorPressed={backgroundColorPressed}
    backgroundColorDisabled={backgroundColorDisabled}
    borderWidth={borderWidth}
    font={font}
    fluid={fluid}
    onClick={onClick}
    {...rest}
  />
)
